import React from 'react'
import { convertFromToUser } from 'utils/users'
import { Link } from 'react-router-dom'
import { CardLink } from 'components/Link'
import { PermissionLevels } from 'utils/permission'
import moment from 'moment'
import RichTextContent from 'components/RichText/Content'
import RichTextInlineContent from 'components/RichText/InlineContent'

const preventEventPropagation = (event) => {
  event.stopPropagation()
}

export default (activity, currentUser, context = 'notifications') => {
  const parsedActivity = {
    ...activity,
    tags: [...activity.tags],
    data: {
      ...activity.data
    }
  }

  const fromUser = convertFromToUser(activity.from)

  const parsedData = {}

  let contextId = null

  if (
    context.substr(0, 6) === 'board-' ||
    context.substr(0, 5) === 'card-'
  ) {
    const parts = context.split('-')
    parsedData.context = parts[0]
    contextId = +parts[1]
  } else {
    parsedData.context = context
  }

  const data = activity.data

  Object.keys(activity.data).forEach(key => {
    const value = data[key]

    parsedData[key] = value

    switch (key) {
      case 'cardName':
        if (data.cardId) {
          parsedData[key] = <CardLink cardId={data.cardId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'parentName':
        if (data.parentId) {
          parsedData.parentCardName = <CardLink cardId={data.parentId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'childCardName':
        if (data.childCardId) {
          parsedData.childCardName = <CardLink cardId={data.childCardId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'oldParentName':
        if (data.oldParentId) {
          parsedData.oldParentCardName = <CardLink cardId={data.oldParentId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'prevCardName':
        if (data.prevCardId) {
          parsedData.prevCardName = <CardLink cardId={data.prevCardId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'succCardName':
        if (data.succCardId) {
          parsedData.succCardName = <CardLink cardId={data.succCardId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'templateCardName':
        if (data.templateCardId) {
          parsedData.templateCardName = <CardLink cardId={data.templateCardId} onClick={preventEventPropagation}>{value}</CardLink>
        }
        break
      case 'boardName':
        if (data.boardId) {
          parsedData.boardName = <Link to={'/board/' + data.boardId} onClick={preventEventPropagation}>{value}</Link>
        }
        break
      case 'parentBoardName':
        if (data.parentBoardId) {
          parsedData.parentBoardName = <Link to={'/board/' + data.parentBoardId} onClick={preventEventPropagation}>{value}</Link>
        }
        break
      case 'oldParentBoardName':
        if (data.oldParentBoardId) {
          parsedData.oldParentBoardName = <Link to={'/board/' + data.oldParentBoardId} onClick={preventEventPropagation}>{value}</Link>
        }
        break
      case 'homeLayoutName':
        if (data.homeLayoutId) {
          parsedData.homeLayoutName = <Link to={'/home/' + data.homeLayoutId} onClick={preventEventPropagation}>{value}</Link>
        }
        break
      case 'documentsListItemName':
      case 'filename':
        if (data.url) {
          parsedData[key] = <a href={data.url} target='_blank' rel='noopener noreferrer' onClick={preventEventPropagation}>{value}</a>
        }
        break
      case 'checklistItemRtName':
        parsedData['checklistItemName'] =
          <span style={{ fontWeight: 500 }}><RichTextInlineContent content={data[key]} /></span>
        break
      case 'oldChecklistItemRtName':
        parsedData['oldChecklistItemName'] =
          <span style={{ fontWeight: 500 }}><RichTextInlineContent content={data[key]} /></span>
        break
      case 'groupName':
      case 'userName':
      case 'listName':
      case 'elementName':
      case 'labelName':
      case 'docSourceName':
      case 'statusName':
      case 'oldStatusName':
      case 'calendarEventName':
      case 'oldBoardName':
      case 'oldListName':
      case 'oldElementName':
      case 'oldLabelName':
      case 'oldCardName':
      case 'oldChecklistItemName':
      case 'oldCalendarEventName':
      case 'eventName':
      case 'planName':
      case 'blockerName':
      case 'oldBlockerName':
      case 'reason':
        parsedData[key] = <span style={{ fontWeight: 500 }}>{value}</span>
        break
      default:
        break
    }
  })

  switch (data.action) {
    case 'CopyBoard':
    case 'AddBoardFromTemplate':
      if (data.oldBoardId) {
        parsedData.oldBoardName = <Link to={'/board/' + data.oldBoardId} onClick={preventEventPropagation}>{data.oldBoardName}</Link>
      }
      break
    case 'MoveCard':
      if (data.boardName === null) {
        parsedData.unknownName = 'boardName'
      } else if (data.oldBoardName === null) {
        parsedData.unknownName = 'oldBoardName'
      } else {
        parsedData.unknownName = 'other'
      }
      if (data.oldBoardId) {
        parsedData.oldBoardName = <Link to={'/board/' + data.oldBoardId} onClick={preventEventPropagation}>{data.oldBoardName}</Link>
      }
      break
    case 'CopyCard':
      if (data.oldCardId) {
        if (parsedData.context === 'card' && contextId === data.oldCardId) {
          parsedData.context = 'oldCard'
        }
        parsedData.oldCardName = <CardLink cardId={data.oldCardId} onClick={preventEventPropagation}>{data.oldCardName}</CardLink>
      }
      break
    case 'AddCardFromTemplate':
    case 'ApplyCardTemplate':
      if (data.oldCardId) {
        parsedData.oldCardName = <CardLink cardId={data.oldCardId} onClick={preventEventPropagation}>{data.oldCardName}</CardLink>
      }
      break
    case 'ConvertChecklistItemToCard':
      if (data.oldCardId) {
        if (parsedData.context === 'card' && contextId === data.oldCardId) {
          parsedData.context = 'oldCard'
        }
        parsedData.oldCardName = <CardLink cardId={data.oldCardId} onClick={preventEventPropagation}>{data.oldCardName}</CardLink>
      }
      break
    case 'AddUserToCard':
    case 'RemoveUserFromCard':
    case 'MakeUserResponsible':
    case 'RemoveFromGroup':
    case 'RemoveUserFromGroup':
    case 'RemoveUserFromBoard':
    case 'RemoveUserFromHomeLayout':
    case 'ChangeCardBlockerUser':
      if (typeof data.userId !== 'undefined') {
        if (fromUser.type === 'USER' && data.userId === fromUser.id) {
          parsedData.targetUser = 'self'
        } else if (data.userId === currentUser.id) {
          parsedData.targetUser = 'you'
        } else {
          parsedData.targetUser = 'other'
        }
      }
      break
    case 'AddToGroup':
    case 'AddUserToGroup':
    case 'AddUserToBoard':
    case 'ChangeUserPermissionLevelInBoard':
    case 'AddUserToHomeLayout':
    case 'ChangeUserPermissionLevelInHomeLayout':
      if (typeof data.userId !== 'undefined') {
        if (fromUser.type === 'USER' && data.userId === fromUser.id) {
          parsedData.targetUser = 'self'
        } else if (data.userId === currentUser.id) {
          parsedData.targetUser = 'you'
        } else {
          parsedData.targetUser = 'other'
        }
      }

      if (typeof data.permissionLevel !== 'undefined') {
        switch (data.permissionLevel) {
          case PermissionLevels.OWNER:
            parsedData.permissionLevel = 'owner'
            break
          case PermissionLevels.MEMBER:
            parsedData.permissionLevel = 'member'
            break
          case PermissionLevels.VISITOR:
            parsedData.permissionLevel = 'visitor'
            break
          default:
            parsedData.permissionLevel = 'other'
            break
        }
      }

      break
    case 'AddCommentOnCard':
    case 'EditCommentOnCard':
    case 'AddBoardChatMessage':
    case 'AddBoardChatReply':
      parsedData.message = (
        <RichTextContent content={data.rtMessage} />
      )
      break
    case 'SendEmailFromCard':
      parsedData.message = (
        <RichTextContent content={data.rtMessage} />
      )
      parsedData.emails = data.to
      break
    case 'SetDueDate':
      parsedData.dueDate = data.dueDate
      break
    case 'SetStartDate':
      parsedData.startDate = data.timestamp
      break
    case 'AddCustomDate':
    case 'SetCustomDate':
      parsedData.date = data.timestamp
      break
    case 'AddCardParent':
      if (parsedData.context === 'card' && contextId === data.cardId) {
        parsedData.context = 'subCard'
      } else {
        parsedActivity.data.cardId = data.parentId
        parsedActivity.data.cardName = data.parentName
        parsedActivity.data.boardId = data.parentBoardId
        parsedActivity.data.boardName = data.parentBoardName
      }
      break
    case 'RemoveCardParent':
      if (parsedData.context === 'card' && contextId === data.cardId) {
        parsedData.context = 'subCard'
      } else {
        parsedActivity.data.cardId = data.oldParentId
        parsedActivity.data.cardName = data.oldParentName
        parsedActivity.data.boardId = data.oldParentBoardId
        parsedActivity.data.boardName = data.oldParentBoardName
      }
      break
    case 'AddCardSuccessor':
    case 'RemoveCardSuccessor':
      if (parsedData.context === 'card') {
        if (contextId === data.succCardId) {
          parsedData.context = 'succCard'
        } else {
          parsedData.context = 'predCard'
        }
      }
      break
    case 'AlarmStartDate':
    case 'AlarmDueDate':
    case 'AlarmDueDateChildCard':
    case 'AlarmDueDatePredecessorCard':
    case 'AlarmCustomDate':
    case 'AlarmPersonalDate': {
      const minutesDiff = moment(parsedData.eventTimestamp).diff(parsedData.timestamp, 'minutes')
      if (minutesDiff <= 0) {
        parsedData.timeDiffType = 'overdue'
      } else if (minutesDiff < 60) {
        parsedData.timeDiffType = 'minutes'
        parsedData.timeDiff = minutesDiff
      } else if (minutesDiff < 1440) { // 24 hours
        parsedData.timeDiffType = 'hours'
        parsedData.timeDiff = Math.floor(minutesDiff / 60)
      } else {
        parsedData.timeDiffType = 'days'
        parsedData.timeDiff = Math.floor(minutesDiff / 1440)
      }
      break
    }
    case 'RemoveBlockerFromCard':
    case 'ChangeCardBlockerReason':
    case 'RemoveBlockerFromChildCard':
    case 'RemoveBlockerFromPredecessorCard':
      if (data.reason) {
        parsedData.withReason = true
      } else {
        parsedData.withReason = false
      }
      break
    case 'AddBlockerToCard':
    case 'AddBlockerToChildCard':
    case 'AddBlockerToPredecessorCard':
      if (typeof data.userId !== 'undefined') {
        if (fromUser.type === 'USER' && data.userId === fromUser.id) {
          parsedData.targetUser = 'self'
        } else if (data.userId === currentUser.id) {
          parsedData.targetUser = 'you'
        } else {
          parsedData.targetUser = 'other'
        }
      }

      if (data.reason) {
        parsedData.withReason = true
      } else {
        parsedData.withReason = false
      }

      break
    default:
      break
  }

  return {
    ...parsedActivity,
    parsedData
  }
}
